import { SettingsResCommon } from '@/views/dashboard/policy/policy-common.service'
import { StrategySettings } from '@/views/dashboard/data-safe/usb-manage/usb-policy/usb-policy.service'

export const DEFAULT_SETTING: StrategySettings = {
  control_type: 2,
  is_remind: false,
  white_list: []
}

export interface SettingsRes extends SettingsResCommon {
  /** 策略内容(json) ，特定的类型才返回，如软件禁用策略 */
  strategy: StrategySettings
}
